import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, NavLink } from "react-router-dom";
import {
  default as fav_ar,
  default as headerlogo_ar,
} from "../Images/arabic-logo.png";
import {
  default as fav_en,
  default as headerlogo_en,
} from "../Images/tararide_header.png";

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [lang, setLang] = useState("EN");

  const { t, i18n } = useTranslation();

  // Scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // RTL support
  useEffect(() => {
    document.documentElement.dir = i18n.language === "ar" ? "rtl" : "ltr";
  }, [i18n.language]);

  useEffect(() => {
    const savedLang = localStorage.getItem("lang");

    if (savedLang) {
      i18n.changeLanguage(savedLang);
      setLang(savedLang === "ar" ? "AR" : "EN");
    }
  }, []);

  const currentLang = i18n.language;

  const mainLogo = currentLang === "ar" ? headerlogo_ar : headerlogo_en;
  const smallLogo = currentLang === "ar" ? fav_ar : fav_en;
  return (
    <>
      <nav
        className={`navbar navbar-expand-lg navbar-light navbar-wrapped ${
          isScrolled ? "scrolled-nav" : ""
        }`}
      >
        <div className="container">
          {/* Logo */}
          <Link to="/">
            {!isScrolled ? (
              <img src={mainLogo} alt="Logo" className="header-logo" />
            ) : (
              <img
                src={smallLogo}
                alt="Favicon"
                className="header-fevicon-logo"
              />
            )}
          </Link>

          {/* Menu */}
          <div
            className="collapse navbar-collapse justify-content-center order-3 order-lg-0 w-lg-auto"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav mb-2 mb-lg-0">
              <li className="nav-item">
                <NavLink
                  to="/"
                  end
                  className={({ isActive }) =>
                    isActive
                      ? "nav-link nav-list active-header"
                      : "nav-link nav-list text-white"
                  }
                >
                  {t("home")}
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink to="/about-us" className="nav-link nav-list">
                  {t("about")}
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink to="/services" className="nav-link nav-list">
                  {t("services")}
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink to="/choose-us" className="nav-link nav-list">
                  {t("choose")}
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink to="/contact-us" className="nav-link nav-list">
                  {t("contact")}
                </NavLink>
              </li>

              <li className="nav-item  mt-2 d-lg-none">
                <a href="https://tararide.com/get-started">
                  <button className="button-wrapping wave-btn w-100">
                    {t("cta")}
                  </button>
                </a>
              </li>
            </ul>
          </div>

          {/* Right Section */}
          <div className="d-flex align-items-center gap-2 ms-auto">
           
            <div className="dropdown">
              <button
                type="button"
                className="btn dropdown-toggle d-flex align-items-center gap-2 rounded-pill px-3 py-1"
                style={{ background: "#eef5d0" }}
                data-bs-toggle="dropdown"
              >
          
                <img
                  src={
                    lang === "EN"
                      ? "https://flagcdn.com/w40/us.png"
                      : "https://flagcdn.com/w40/sa.png"
                  }
                  alt="flag"
                  style={{
                    width: "18px",
                    height: "18px",
                    borderRadius: "50%",
                  }}
                />

                {/* Text */}
                <span className="fw-semibold">{lang}</span>
              </button>

              <ul className="dropdown-menu dropdown-menu-end shadow border-0 rounded-3 mt-2">
                <li>
                  <button
                    className="dropdown-item d-flex align-items-center gap-2"
                    onClick={() => {
                      setLang("EN");
                      i18n.changeLanguage("en");
                      localStorage.setItem("lang", "en");
                    }}
                  >
                    <img
                      src="https://flagcdn.com/w40/us.png"
                      style={{
                        width: "18px",
                        height: "18px",
                        borderRadius: "50%",
                      }}
                    />
                    English
                  </button>
                </li>

                <li>
                  <button
                    className="dropdown-item d-flex align-items-center gap-2"
                    onClick={() => {
                      setLang("AR");
                      i18n.changeLanguage("ar");
                      localStorage.setItem("lang", "ar");
                    }}
                  >
                    <img
                      src="https://flagcdn.com/w40/sa.png"
                      style={{
                        width: "18px",
                        height: "18px",
                        borderRadius: "50%",
                      }}
                    />
                    Arabic
                  </button>
                </li>
              </ul>
            </div>

          
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            {/* CTA */}
            <a
              href="https://tararide.com/get-started"
              rel="noopener noreferrer"
              className="d-none d-lg-block"
            >
              <button className="button-wrapping wave-btn">{t("cta")}</button>
            </a>
            </div>
        </div>
      </nav>
    </>
  );
}

export default Header;
